"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "finale-emilia": {
    "a96cd8e2": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "ca-bianca": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bb259623": [{
      "hkey": "e088711b",
      "slug": "massa-finalese-canaletto",
      "name": "Massa Finalese-Canaletto",
      "primary": true,
      "skipSearch": false
    }],
    "canaletto": [{
      "hkey": "e088711b",
      "slug": "massa-finalese-canaletto",
      "name": "Massa Finalese-Canaletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "finale-emilia"
    }],
    "54fc1b38": [{
      "hkey": "e088711b",
      "slug": "massa-finalese-canaletto",
      "name": "Massa Finalese-Canaletto",
      "primary": true,
      "skipSearch": false
    }],
    "massa-finalese": [{
      "hkey": "e088711b",
      "slug": "massa-finalese-canaletto",
      "name": "Massa Finalese-Canaletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2c6c8566": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "obici": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8628407f": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "villa-rovere": [{
      "hkey": "29f77795",
      "slug": "finale-emilia",
      "name": "Finale Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;